export enum FiatCurrencyExchangeSource {
  VamPrivet = 'vamprivet',
  Cbr = 'cbr',
  Manual = 'manual',
}
